export function trackIdsToFilterFormat(text) {
    // Split by underscores and take the last two elements
    const parts = text.split("_").slice(-2);

    // Join them, replace dashes with spaces, and capitalize each word
    return parts
        .join(" ")
        .replace(/-/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
}